import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Inject } from '@angular/core';
import { LoaderService } from '../../../shared/services/loader.service';
import { Observable } from 'rxjs';
import { DonationService } from '../../../shared/services/donation.service';
import { DataTableParams } from 'angular-datatables-all-versions';
export class DonationsListResolver implements Resolve<any[]> {

    constructor(@Inject(DonationService) private service: DonationService,
        @Inject(LoaderService) private loaderService: LoaderService) { }

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any[]> {
        this.loaderService.show();
        const post_data = <DataTableParams>Object.assign({}, {
            type: route.paramMap.get('type')
        })
        return this.service.list(post_data);
    }
}
